import { render, staticRenderFns } from "./CsDeletes.vue?vue&type=template&id=fe5ffda6&"
import script from "./CsDeletes.vue?vue&type=script&lang=js&"
export * from "./CsDeletes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports